export default __webpack_public_path__ + "static/media/3.04e9b057.webp";